import { lazy } from "react";
const SSOLoginPage = lazy(() => import("../views/PreLogin/SSOLogin"));
const SSOCallback = lazy(() => import("../views/PreLogin/SSOCallback"));
// const ForgtPassword = lazy(() => import("../views/PreLogin/ForgotPasswordEmail"));
// const SetNewPassword = lazy(() => import("../views/PreLogin/SetNewPassword"));
// const ResetSuccessful = lazy(() => import("../views/PreLogin/ResetSuccessful"));

export const PreLoginRoutes = [
  {
    path: "/login",
    element: <SSOLoginPage />,
  },
  {
    path: "/dashboard/authentication/sso-callback",
    element: <SSOCallback />,
  },
  // {
  //   path: "/forgot-password",
  //   element: <ForgtPassword />,
  // },
  // {
  //   path: "/set-password",
  //   element: <SetNewPassword />,
  // },
  // {
  //   path: "/reset-successful",
  //   element: <ResetSuccessful />,
  // },
];
